import React from 'react';
import { X } from 'lucide-react';
import { colors, typography, radius, spacing } from '../../../theme';

/**
 * Full personal-bests list — same bottom-sheet pattern as
 * progress/AllExercisesDrilldown.jsx. Tapping a row passes the full PR
 * record (not just the name) so the caller can look up its progression via
 * getPRProgression(userId, exercise_name, rep_range, is_assisted).
 */
const PersonalBestsFull = ({ prs, onClose, onSelectExercise }) => {
  if (!prs) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.sheet} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <div style={{ ...typography.sectionHeading, color: colors.text }}>Personal Bests</div>
          <button onClick={onClose} style={styles.closeBtn}>
            <X size={18} color={colors.textMuted} />
          </button>
        </div>
        <div style={styles.list}>
          {prs.map((pr) => (
            <button
              key={`${pr.exercise_name}|${pr.rep_range}`}
              onClick={() => onSelectExercise?.(pr)}
              style={styles.row}
            >
              <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                <div style={{ ...typography.body, color: colors.text, fontWeight: '600' }}>{pr.exercise_name}</div>
                <div style={{ display: 'flex', gap: spacing.md, marginTop: '4px' }}>
                  <span style={{ ...typography.caption, color: colors.textMuted }}>
                    {pr.weight} kg × {pr.reps}
                  </span>
                  {pr.rep_range && (
                    <span style={{ ...typography.caption, color: colors.textSubtle }}>{pr.rep_range} reps</span>
                  )}
                </div>
              </div>
              <span style={{ color: colors.textSubtle, fontSize: '16px', flexShrink: 0 }}>›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0, 0, 0, 0.75)',
    display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    zIndex: 1000,
  },
  sheet: {
    width: '100%', maxWidth: '480px', maxHeight: '85vh',
    background: colors.surface1,
    borderTopLeftRadius: radius.modal, borderTopRightRadius: radius.modal,
    padding: spacing.lg,
    overflowY: 'auto',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    marginBottom: spacing.lg,
  },
  closeBtn: {
    background: colors.surface2, border: 'none', borderRadius: '50%',
    width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer',
  },
  list: { display: 'flex', flexDirection: 'column', gap: spacing.sm },
  row: {
    display: 'flex', alignItems: 'center', gap: spacing.md,
    width: '100%',
    padding: `${spacing.sm} ${spacing.md}`,
    backgroundColor: colors.surface2, borderRadius: radius.sm,
    border: `1px solid ${colors.border}`,
    cursor: 'pointer',
  },
};

export default PersonalBestsFull;
